module.exports = __webpack_public_path__ + "img/logo_login.de5e8bcf.png";